import {createFileRoute, Outlet} from '@tanstack/react-router';

import {ImagesCacheProvider} from 'src/contexts/ImagesCacheProvider';

export const Route = createFileRoute('/archive')({
  component: ArchiveLayout,
});

function ArchiveLayout() {
  return (
    <ImagesCacheProvider mode='archive'>
      <Outlet />
    </ImagesCacheProvider>
  );
}
